import styled from "styled-components";
import variables from "../../theme/variables";
export const LoadingContainer = styled.div`
  display: ${(props) => (props.doNot ? "none" : "block")};
  background-color: ${variables.colors.background};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  opacity: ${(props) => (props.status ? 1 : 0)};
  transition: 1s all;
  .start,
  .loop,
  .logo-motion {
    position: absolute;
    right: calc(50% - 250px);
    bottom: calc(50% - 250px);
    width: 500px;
    min-height: 500px;
  }
  .git-mode {
    display: none;
    height: 100%;
    img{
      width: 96px;
    }
  }
  @supports (-webkit-touch-callout: none) {
    .video-mode {
      display: none;
    }
    .git-mode {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .start {
    display: ${(props) => (props.videoStatus === "start" ? "block" : "none")};
  }
  .loop {
    display: ${(props) => (props.videoStatus === "loop" ? "block" : "none")};
  }
  .logo-motion {
    display: ${(props) => (props.videoStatus === "logo" ? "block" : "none")};
  }
`;
